export class EmployerInvoiceItem {
  id: string;
  operationType: string;
  employeeName: string;
  employeeStatus: string;
  employeeHeadOfficeIdentity: string;
  userSocialSecurityNumber: string;
  ccbNumber: string;
  amount: number;
  type: string;

  constructor(data: any | EmployerInvoiceItem | DjangoEmployerInvoiceItem = {}) {
    if (data instanceof EmployerInvoiceItem) {
      bindEmployerInvoiceItem(this, data);
    } else {
      bindDjangoEmployerInvoiceItem(this, data);
    }
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////

export interface DjangoEmployerInvoiceItem {
  id: string;
  operation_type: string;
  employee_name: string;
  employee_status: string;
  employee_head_office_identity: string;
  user_social_security_number: string;
  ccb_number: string;
  amount: string;
  type: string;
}

function bindEmployerInvoiceItem(invoiceItem: EmployerInvoiceItem, data: EmployerInvoiceItem) {
  invoiceItem.id = data.id;
  invoiceItem.employeeName = data.employeeName;
  invoiceItem.employeeStatus = data.employeeStatus;
  invoiceItem.employeeHeadOfficeIdentity = data.employeeHeadOfficeIdentity;
  invoiceItem.userSocialSecurityNumber = data.userSocialSecurityNumber;
  invoiceItem.ccbNumber = data.ccbNumber;
  invoiceItem.amount = data.amount;
  invoiceItem.type = data.type;
}

function bindDjangoEmployerInvoiceItem(
  invoiceItem: EmployerInvoiceItem,
  data: DjangoEmployerInvoiceItem,
) {
  invoiceItem.id = data.id;
  invoiceItem.employeeName = data.employee_name;
  invoiceItem.employeeStatus = data.employee_status;
  invoiceItem.employeeHeadOfficeIdentity = data.employee_head_office_identity;
  invoiceItem.userSocialSecurityNumber = data.user_social_security_number;
  invoiceItem.ccbNumber = data.ccb_number;
  invoiceItem.amount = Number(data.amount);
  invoiceItem.type = data.type;
}
